import { render, staticRenderFns } from "./FairPayStatusShort.vue?vue&type=template&id=189659bd&scoped=true"
import script from "./FairPayStatusShort.vue?vue&type=script&setup=true&lang=js"
export * from "./FairPayStatusShort.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FairPayStatusShort.vue?vue&type=style&index=0&id=189659bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189659bd",
  null
  
)

export default component.exports